<template>
    <div id="price" class="radius_wrapper orange_ver">
<!--        <div style="font-size: 0.8rem; line-height: 1.5rem;">-->
<!--        生地価格ファイル：{{$store.state.price_data.price_file}} &yen;{{$store.state.price_data.price}}<br>-->
<!--        裏地価格ファイル：{{$store.state.price_data.price_ura_file}} &yen;{{$store.state.price_data.price_ura}}<br>-->
<!--        加算価格ファイル：{{$store.state.price_data.price_add_file}} &yen;{{$store.state.price_data.price_add}}<br>-->
<!--        後幕価格ファイル：{{$store.state.price_data.price_atomaku_file}} &yen;{{$store.state.price_data.price_atomaku}}<br><br>-->
<!--        </div>-->
        <p>お選びのカーテン</p>

        <table class="price_table">
            <tr>
                <th><div>品番</div></th>
                <td>
                    <div v-if="$store.state.step1_data.item_number != ''">
                        ME&nbsp;{{$store.state.step1_data.item_number}}
                    </div>
                </td>
            </tr>
            <tr>
                <th><div>スタイル</div></th>
                <td>
                    <span v-if="$store.state.step2_data.style_selected1_id !== ''">
                    {{$store.state.xlsx_data.style_data[$store.state.step2_data.style_selected1_id].name}}<br>
                    </span>
                    <span v-if="$store.state.step2_data.style_selected2_id !== ''">
                    {{$store.state.xlsx_data.style_data[$store.state.step2_data.style_selected2_id].name}}<br>
                    </span>
<!--                    <div>RJ 23</div>-->
<!--                    ソフトウェーブ ボトムボーダー-->
<!--                    <span>※ボーダーはFT0000～0000です。</span>-->
                </td>
            </tr>
            <tr>
                <th><div>縫製仕様</div></th>
                <td><span v-if="is_show">
                    <p style="margin:0 0 0.2rem 0;" v-if="group2_1 !== 'ベッドスプレッド' && group1_1 !=='クッション'">巾{{$store.state.step3_data.width_size}}cm &nbsp;&nbsp; 丈{{$store.state.step3_data.height_size}}cm</p>
                    <table>
                        <tr v-if="$store.state.step3_data.hida && group1_1==='カーテン'">
                            <td style="padding: 0.2rem; padding-left:0rem;">倍率・ヒダスタイル</td>
                            <td style="padding: 0.2rem">{{$store.state.step3_data.hida}}</td>
                        </tr>
                        <tr v-if="$store.state.step3_data.ura && (group1_1=='カーテン' || group2=='ローマンシェード シングル') && item_data && item_data['ドレープ/レース'] === 'ドレープ'">
                            <td style="padding: 0.2rem; padding-left:0rem;">裏地</td>
                            <td style="padding: 0.2rem">{{$store.state.step3_data.ura}}</td>
                        </tr>
                        <tr v-if="$store.state.step3_data.open && group1_1==='カーテン'">
                            <td style="padding: 0.2rem; padding-left:0rem;">開閉方法</td>
                            <td style="padding: 0.2rem">{{$store.state.step3_data.open}}</td>
                        </tr>
                        <tr v-if="$store.state.step3_data.suso && group1_1==='カーテン' && suso_options.length > 1">
                            <td style="padding: 0.2rem; padding-left:0rem;">裾形状</td>
                            <td style="padding: 0.2rem">{{$store.state.step3_data.suso}}</td>
                        </tr>
                        <tr v-if="$store.state.step3_data.mecha">
                            <td style="padding: 0.2rem; padding-left:0rem;">操作メカ</td>
                            <td style="padding: 0.2rem">{{$store.state.step3_data.mecha}}</td>
                        </tr>
                        <tr v-if="$store.state.step3_data.kurumi">
                            <td style="padding: 0.2rem; padding-left:0rem;">仕様</td>
                            <td style="padding: 0.2rem">{{$store.state.step3_data.kurumi}}</td>
                        </tr>
                        <tr v-if="$store.state.step3_data.cloth">
                            <td style="padding: 0.2rem; padding-left:0rem;">クロス</td>
                            <td style="padding: 0.2rem">{{$store.state.step3_data.cloth}}</td>
                        </tr>
                        <tr v-if="$store.state.step3_data.trim">
                            <td style="padding: 0.2rem; padding-left:0rem;">トリム品番</td>
                            <td style="padding: 0.2rem">{{$store.state.step3_data.trim}}</td>
                        </tr>
                        <tr v-if="$store.state.step3_data.fringe">
                            <td style="padding: 0.2rem; padding-left:0rem;">フリンジ品番</td>
                            <td style="padding: 0.2rem">{{$store.state.step3_data.fringe}}</td>
                        </tr>
                        <tr v-if="$store.state.step3_data.deco_fringe">
                            <td style="padding: 0.2rem; padding-left:0rem;">フリンジ品番</td>
                            <td style="padding: 0.2rem">{{$store.state.step3_data.deco_fringe}}</td>
                        </tr>
                        <tr v-if="$store.state.step3_data.window_number">
                            <td style="padding: 0.2rem; padding-left:0rem;">台数</td>
                            <td style="padding: 0.2rem">{{$store.state.step3_data.window_number}}</td>
                        </tr>
                        <tr v-if="$store.state.step3_data.return_type">
                            <td style="padding: 0.2rem; padding-left:0rem;">リターン</td>
                            <td style="padding: 0.2rem">{{$store.state.step3_data.return_type}}</td>
                        </tr>
                        <tr v-if="$store.state.step1_data.atomaku_number && group2=='ローマンシェード ツイン'">
                            <td style="padding: 0.2rem; padding-left:0rem;">後幕品番</td>
                            <td style="padding: 0.2rem">ME&nbsp;{{$store.state.step1_data.atomaku_number}}</td>
                        </tr>
                        <tr v-if="$store.state.step3_data.atomaku_style && group2=='ローマンシェード ツイン'">
                            <td style="padding: 0.2rem; padding-left:0rem;">後幕スタイル</td>
                            <td style="padding: 0.2rem">{{$store.state.step3_data.atomaku_style}}</td>
                        </tr>
                        <tr v-if="$store.state.step3_data.quilting_type">
                            <td style="padding: 0.2rem; padding-left:0rem;">スタンダード/キルティング</td>
                            <td style="padding: 0.2rem">{{$store.state.step3_data.quilting_type}}</td>
                        </tr>
                        <tr v-if="$store.state.step3_data.finish_size">
                            <td style="padding: 0.2rem; padding-left:0rem;">仕上りサイズ</td>
                            <td style="padding: 0.2rem">{{$store.state.step3_data.finish_size}}</td>
                        </tr>
                        <tr v-if="$store.state.step3_data.bed_size">
                            <td style="padding: 0.2rem; padding-left:0rem;">仕上りサイズ</td>
                            <td style="padding: 0.2rem">{{$store.state.step3_data.bed_size}}</td>
                        </tr>
                        <tr v-if="$store.state.step3_data.select_size && group1_1=='クッション'">
                            <td style="padding: 0.2rem; padding-left:0rem;">仕上りサイズ</td>
                            <td style="padding: 0.2rem">{{$store.state.step3_data.select_size}}</td>
                        </tr>
                    </table>
                    </span>
                </td>
            </tr>
            <tr>
                <th><div>数量</div></th>
                <td>
                    <span v-if="is_show">
                    {{$store.state.step4_data.set_number}}&nbsp;セット
                    </span>
                </td>
            </tr>
            <tr>
                <th><div>施工場所</div></th>
                <td>{{$store.state.step5_data.room_selected}}</td>
            </tr>
        </table>
<!--        <span style="font-size: 0.8rem;">{{style_code}}</span>-->
        <b-row class="sum_price" v-if="priceStyle.fontSize==='1.6rem'">
            <b-col cols="2" class="price_title" style="font-size: 0.9rem;">金額</b-col>
            <b-col v-bind:style="priceStyle" cols="6" class="price_area" style="text-align: right;">{{price}}</b-col>
            <b-col cols="4" class="price_end"><span v-if="priceStyle.fontSize==='1.6rem'">&nbsp;円&nbsp;(税抜)</span></b-col>
        </b-row>
        <b-row class="sum_price" v-else>
            <b-col v-bind:style="priceStyle" cols="12" class="price_area" style="text-align: center;">{{price}}</b-col>
        </b-row>
    </div>
</template>

<script>
    export default {
        name: 'PRICE',
        data() {
            return {
                priceStyle:{fontSize:'1.6rem'},
            }
        },
        computed: {
            is_show: {
                get:function(){
                    if(this.$store.state.step2_data.style_selected1_id !== '' ||  this.$store.state.step2_data.style_selected2_id !== ''){
                        return true
                    }
                    return false
                }
            },
            price: {
                get: function () {
                    const step2_data = this.$store.state.step2_data
                    const step3_data = this.$store.state.step3_data
                    const price = this.$store.state.price_data.price

                    const price_ura = this.$store.state.price_data.price_ura
                    const price_add = this.$store.state.price_data.price_add
                    const price_atomaku = this.$store.state.price_data.price_atomaku
                    let group2 = ''
                    if(this.$store.state.step2_data.style_selected2_id){
                        group2 = this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].group2
                    }

                    if(this.$store.state.step2_data.style_selected1_id === '' &&  this.$store.state.step2_data.style_selected2_id === ''){
                        total_price = '-'
                        this.$store.commit('updatePriceData', {name: 'total_price', value: total_price})
                        return total_price
                    }
                    if(group2 ==='ローマンシェード ツイン' && price_atomaku===0){
                        this.priceStyle['fontSize'] = '0.9rem'
                        total_price = '後幕が製作不可の設定です'
                        this.$store.commit('updatePriceData', {name: 'total_price', value: total_price})
                        return total_price
                    }
                    if(price > 0 && (price_atomaku==='製作不可のサイズです' || price_add==='製作不可のサイズです')){
                        this.priceStyle['fontSize'] = '0.9rem'
                        total_price = '製作不可のサイズです'
                        this.$store.commit('updatePriceData', {name: 'total_price', value: total_price})
                        return total_price
                    }
                    let total_price = price+price_ura+price_add+price_atomaku
                    let price_error = ''
                    this.priceStyle['fontSize'] = '1.6rem'
                    if(price === 0){
                        this.priceStyle['fontSize'] = '0.9rem'
                        total_price = '製作不可のサイズです'
                        let hida = step3_data.hida
                        if(hida==='' || hida === undefined){
                            return total_price
                        }
                        hida = hida.split('/')[0]
                        hida = hida.replace(/約/g,'')
                        if(hida==='1倍'){
                            hida = 'フラット'
                        }else{
                            hida = hida+'ヒダ'
                        }
                        if(
                            step3_data.size_min_max &&
                            step3_data.size_min_max[hida] &&
                            step3_data.size_min_max[hida][step3_data.open]
                        )
                        {
                            if (
                                step3_data.width_size < step3_data.size_min_max[hida][step3_data.open].width_min ||
                                step3_data.width_size > step3_data.size_min_max[hida][step3_data.open].width_max ||
                                step3_data.height_size < step3_data.size_min_max[hida][step3_data.open].height_min ||
                                step3_data.height_size > step3_data.size_min_max[hida][step3_data.open].height_max
                            ) {
                                const price_file = this.$store.state.price_data.price_file
//                                if(price_file.indexOf('SWH') > -1 || price_file.indexOf('SWS') > -1 ||  price_file.indexOf('SWHL') > -1){
                                if(
                                    step2_data.style_selected1_name==='スタンダード縫製' ||
                                    step2_data.style_selected1_name==='ソフトウェーブ縫製'
                                ){
                                    if (
                                        step3_data.width_size > step3_data.size_min_max[hida][step3_data.open].width_max ||
                                        step3_data.height_size > step3_data.size_min_max[hida][step3_data.open].height_max
                                    ) {
                                        this.priceStyle['fontSize'] = '0.9rem'
                                        total_price = '価格についてはお問い合わせください'
                                    }
                                }
                            }
                        }
                    }else{
                        total_price = String(total_price).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
                    }
                    this.$store.commit('updatePriceData', {name: 'total_price', value: total_price})
                    return total_price
                },
            },
            group1_1 : {
                get: function () {
                    if(this.$store.state.step2_data.style_selected1_id !== ''){
                        return this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected1_id].group1
                    }
                    return ''
                },
            },
            group2_1 : {
                get: function () {
                    if(this.$store.state.step2_data.style_selected2_id){
                        return this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].group1
                    }
                    return ''
                },
            },
            group2: {
                get: function () {
                    if(this.$store.state.step2_data.style_selected2_id){
                        return this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].group2
                    }else{
                        return ''
                    }
                },
            },
            style_selected1_name: {
                get: function () {
                    return this.$store.state.step2_data.style_selected1_name
                },
            },
            style_selected2_name: {
                get: function () {
                    return this.$store.state.step2_data.style_selected2_name
                },
            },
            item_data: {
                get: function () {
                    if(
                        this.$store.state.step1_data.item_number &&
                        this.$store.state.xlsx_data.item_data &&
                        typeof(this.$store.state.xlsx_data.item_data['ME'+this.$store.state.step1_data.item_number]) !=='undefined'
                    ){
                        return this.$store.state.xlsx_data.item_data['ME'+this.$store.state.step1_data.item_number]
                    }
                    return ''
                },
            },
            suso_options:{
                get:function(){
                    if(this.$store.state.step2_data.style_selected1_id !== '' && this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected1_id].group1 === 'カーテン'){
                        if(this.$store.state.step2_data.style_selected2_id !==''){
                            return this.$store.state.xlsx_select_data.select_data['カーテン'][this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected2_id].name]['裾形状を選ぶ↓ヨコ使いレース生地のみ'].option
                        }
                        else if(this.$store.state.step2_data.style_selected1_id !==''){
                            return this.$store.state.xlsx_select_data.select_data['カーテン'][this.$store.state.xlsx_data.style_data[this.$store.state.step2_data.style_selected1_id].name]['裾形状を選ぶ↓ヨコ使いレース生地のみ'].option
                        }
                        else{
                            return false
                        }
                    }else{
                        return false
                    }
                }
            },
            style_code:{
                get:function(){
                    let style_code = ''
                    const style_name = (this.$store.state.step2_data.style_selected2_name !=='') ? this.$store.state.step2_data.style_selected2_name : this.$store.state.step2_data.style_selected1_name
                    const style_category = this.$store.state.xlsx_select_data.style_category[style_name]
                    if(typeof(this.$store.state.xlsx_select_data.select_data[style_category][style_name]['スタイルコード']) !== 'undefined'){
                        style_code = 'スタイルコード : '+this.$store.state.xlsx_select_data.select_data[style_category][style_name]['スタイルコード'].option[0].value
                    }
                    return style_code
                }
            },
        },
        methods: {
        }
    }
</script>

<style scoped>

</style>